    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col">
                <h5 class="blue"><i class="fas fa-pencil-alt"></i>&nbsp;Editar estación</h5>
            </div>
        </div>
        <hr>
        <form #formEditarEstaciones="ngForm" (ngSubmit)="formSubmit(formEditarEstaciones)" novalidate="">
            <div class="container-fuid"
                style="overflow-y: auto; padding-right: 20px; overflow-x: hidden;">
                <div class="row">
                    <div class="col col-12">
                        <label class="form-label">IATA <small>(Solo se admiten mayúsculas)</small>:</label>
                        <br>
                        <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="IATA"
                            name="txtIATA" #txtIATA="ngModel" [(ngModel)]='EstacionRQ.IATA' maxlength="3" pattern="^[A-ZÀ-Ñ\s]{3}$" required>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col col-12">
                        <label class="form-label">Descripción:</label>

                        <textarea style="height: 250px;" class="form-control form-control-sm custom-input" placeholder="Descripción"
                            name="txtAreaDescripcion" #txtArea="ngModel" [(ngModel)]='EstacionRQ.descripcion' maxlength="255">
                                                </textarea>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col text-end">
                    <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                        <i class="fa fa-arrow-left"></i>
                        Regresar
                    </button>
                    <button type="submit" [disabled]="!formEditarEstaciones.form.valid"
                        class="side-space btn btn-sm rounded-button btn-success">
                        Aceptar
                        <i class="fa fa-check"></i>
                    </button>
                </div>
            </div>
        </form>

    </div>